export const EXPANDED_MODAL_WIDTH = '95%'
export const EXPANDED_MODAL_HEIGHT = '75vh'
export const EXPANDED_MODAL_TOP = 24
